// src/automation/AutomationSection.js
//
// The "Automation" section of the Pulse Suite landing page. For now ALL
// automations live behind a single "VRMO Automation" card — clicking it opens
// the Automation console (/automation/console), which has the full accordion of
// groups/tasks. We still read the task registry just to show a count on the
// card; it never blocks rendering if the dispatcher is unreachable.

import React from "react";
import { useQuery } from "@tanstack/react-query";
import { getAutomationGroups } from "./api/automation_data";

export default function AutomationSection({ onAutomationClick }) {
  const { data: groups = [], isLoading } = useQuery({
    queryKey: ["automationGroups"],
    queryFn: getAutomationGroups,
    staleTime: 60 * 1000,
  });

  const totalTasks = groups.reduce((n, g) => n + (g.tasks?.length || 0), 0);
  const open = () => onAutomationClick && onAutomationClick({ key: "console" });

  return (
    <section className="analytics-section">
      <div className="section-header">
        <h2 className="section-title">Automation NEW</h2>
      </div>

      <div className="cards-grid">
        <div
          className="analytics-card clickable-card"
          onClick={open}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") open();
          }}
        >
          <div className="card-accent-bar" />
          <div className="card-body">
            <span className="card-label-badge">New</span>
            <div className="card-icon-wrapper">
              <span className="card-icon-text">VRMO Automation</span>
            </div>
            <p className="card-description">
              {isLoading
                ? "Loading automations…"
                : totalTasks > 0
                ? `${totalTasks} automation${totalTasks === 1 ? "" : "s"}`
                : "Scheduled & on-demand automations"}
            </p>
            <div className="card-footer">
              <span className="card-explore">Open console</span>
              <span className="card-arrow">→</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
